import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function SiteLoader(){
  const {loading}=useAuth()
  const location=useLocation()
  const [routeLoading,setRouteLoading]=useState(true)
  const first=useRef(true)

  useEffect(()=>{
    setRouteLoading(true)
    const delay=first.current?620:320
    first.current=false
    const timer=window.setTimeout(()=>setRouteLoading(false),delay)
    return()=>window.clearTimeout(timer)
  },[location.pathname,location.search])

  const visible=loading||routeLoading
  return <div className={`site-loader ${visible?'is-visible':'is-hidden'}`} aria-hidden={!visible}>
    <div className="site-loader-logo-wrap">
      <img src="/hnd-study-hub-logo.png" alt="" className="site-loader-logo ghost"/>
      <div className="site-loader-color"><img src="/hnd-study-hub-logo.png" alt="" className="site-loader-logo"/></div>
    </div>
    <span>HND Study Hub</span>
    <i/>
  </div>
}
